
<template>
  <div class="wrapper" v-if='pageshow'>
    <div class="work-bg">
      <div class="flex bottom-bor">
        <div class="work-user">
          <img :src="userdata.headerimg" alt="">
        </div>
        <div class="flex-box user-text">
          <h1>{{userdata.username}} <i class="iconfont iconVIP1" :style="!userdata.levelname?'color:#9e9e9e':''"></i><em>{{userdata.levelname}}</em></h1>
          <h2>活动圈号:{{usercode}}<i v-if="usercode" v-clipboard:copy="usercode"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError" class="iconfont iconfuzhi"></i></h2>
          <h2>手机号:{{userdata.mobile}}</h2>
          <!-- <div class="work-text">
            <div class="textvalue" @click='tocommunity(1)'>
              <h5>{{userdata.markcount}}</h5>
              <p>关注</p>
            </div>
            <div class="textvalue" @click='tocommunity(2)'>
              <h5>{{userdata.fanscount}}</h5>
              <p>粉丝</p>
            </div>
          </div> -->
          <h2>
             <span @click='tocommunity(1)'>{{userdata.markcount}} 关注</span>
             <span @click='tocommunity(2)'>{{userdata.fanscount}} 粉丝</span>
          </h2>
        </div>
        <div class="work-button">
          <button v-if='usercode==userinfo.usercode' @click='setmydata'>编辑资料</button>
          <div><button style="background: #ae8359;margin-top: 10px;" @click='tomembership'>会员中心</button></div>
        </div>
      </div>
      <!-- <div class="work-body" v-show='userdata.org'>//机构介绍
        <i>{{userdata.org}}</i>
        <p>{{userdata.orgintro}}</p>
      </div> -->
    </div>
    <div class="flex flex-white" @click='tomembership' v-if="0>1"><!-- !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!1 -->
      <div class="member">会员中心</div>
      <div class="flex-box">
        <p>再积34834分经验值可以兑换高级会员</p>
      </div>
      <div class="arrow"></div>
    </div>
    <mt-swipe :auto="2000" :showIndicators='true' v-if='isshowbannner'>
      <mt-swipe-item v-for="(item,index) in banner" v-bind:key="item.id"><img :src="item.path" :data-path="item.linkurl"  v-on:click="bannnerlink($event)"></mt-swipe-item>
      <span>广  告</span>
    </mt-swipe>
    <div class="white-box">
      <div class="flex" @click="tomyorder(0)">
        <div class="flex-box">
          <h2>我的订单</h2>
        </div>
        <div class="arrow">
          <span>查看全部</span>
        </div>
      </div>
      <div class="flex" @click="tomyticket(0)">
        <div class="flex-box">
          <h2>我的票券</h2>
        </div>
        <div class="arrow">
          <span>查看全部</span>
        </div>
      </div>
      <div class="flex" @click="tomysign(0)">
        <div class="flex-box">
          <h2>我的报名</h2>
        </div>
        <div class="arrow">
          <span>查看全部</span>
        </div>
      </div>
      <div class="flex" @click="tomyteam()">
        <div class="flex-box">
          <h2>我的团队</h2>
        </div>
        <div class="arrow">
          <span>查看全部</span>
        </div>
      </div>
      <!-- <div class="palace clearfix">
        <div class="palace-grid" style="width:33.33%" v-for="(item,index) in 3"  @click="tomyorder(index)">
          <div class="palace-grid-icon">
            <i class="iconfont icondingdan bluecolor" v-if="index==0"></i>
            <i class="iconfont icondaizhifu yellowcolor" v-if="index==2"></i>
            <i class="iconfont icondaizhifudingdan yellowcolor" v-if="index==1"></i>
          </div>
          <div class="palace-grid-text">
            <h2 v-if="index==0">全部订单</h2>
            <h2 v-if="index==2">已支付</h2>
            <h2 v-if="index==1">待支付</h2>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div class="white-box">
      <div class="flex">
        <div class="flex-box">
          <h2>我的票券</h2>
        </div>
        <div class="arrow" @click="tomyticket(0)">
          <span>查看全部</span>
        </div>
      </div>
      <div class="palace clearfix">
        <div class="palace-grid" v-for="(item,index) in 4"  @click="tomyticket(index)">
          <div class="palace-grid-icon">
            <i class="iconfont iconyouhuiquan bluecolor" v-if="index==0"></i>
            <i class="iconfont icondianyingpiao yellowcolor" v-if="index==1"></i>
            <i class="iconfont iconqupiao yellowcolor" v-if="index==2"></i>
            <i class="iconfont icontuipiao yellowcolor" v-if="index==3"></i>
          </div>
          <div class="palace-grid-text">
            <h2 v-if="index==0">全部票券</h2>
            <h2 v-if="index==1">已使用</h2>
            <h2 v-if="index==2">待使用</h2>
            <h2 v-if="index==3">已退款</h2>
          </div>
        </div>
      </div>
    </div>
    <div class="white-box">
      <div class="flex">
        <div class="flex-box">
          <h2>我的报名</h2>
        </div>
        <div class="arrow"@click="tomysign(0)">
          <span>查看全部</span>
        </div>
      </div>
      <div class="palace clearfix">
        <div class="palace-grid" v-for="(item,index) in 4" @click="tomysign(index)">
          <div class="palace-grid-icon">
            <i class="iconfont iconbianji bluecolor" v-if="index==0"></i>
            <i class="iconfont iconbofangjilu yellowcolor" v-if="index==1"></i>
            <i class="iconfont iconchenggong yellowcolor" v-if="index==2"></i>
            <i class="iconfont iconshibai yellowcolor" v-if="index==3"></i>
          </div>
          <div class="palace-grid-text">
            <h2 v-if="index==0">全部报名</h2>
            <h2 v-if="index==1">待审核</h2>
            <h2 v-if="index==2">已通过</h2>
            <h2 v-if="index==3">未通过</h2>
          </div>
        </div>
      </div>
    </div> -->
    <div class="white-box">
      <div class="flex">
        <div class="flex-box">
          <h2>我的服务</h2>
        </div>
        <!-- <div class="arrow">
          <span>查看全部</span>
        </div> -->
      </div>
      <div class="palace clearfix">
        <div class="palace-grid" @click="toactivity">
          <div class="palace-grid-icon">
            <i class="iconfont iconshangquan redcolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>活动圈活动</h2>
            <h3></h3>
          </div>
        </div>
        <div class="palace-grid" @click="tomatch">
          <div class="palace-grid-icon">
            <i class="iconfont iconpaihangbang redcolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>活动圈比赛</h2>
            <h3></h3>
          </div>
        </div>
        <div class="palace-grid" @click="toarticle">
          <div class="palace-grid-icon">
            <i class="iconfont iconhuati redcolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>活动圈媒体</h2>
            <h3></h3>
          </div>
        </div>
        <div class="palace-grid" @click='tomembership'>
          <div class="palace-grid-icon">
            <i class="iconfont iconyingchengka yellowcolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>会员专区</h2>
            <h3></h3>
          </div>
        </div>

        <div class="palace-grid" @click="tocommunity('')">
          <div class="palace-grid-icon">
            <i class="iconfont iconxiangkan yellowcolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>粉丝&关注</h2>
            <h3></h3>
          </div>
        </div>
        <div class="palace-grid" @click='toprofit'>
          <div class="palace-grid-icon">
            <i class="iconfont iconyinhangka yellowcolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>我的收益</h2>
            <h3></h3>
          </div>
        </div>
        <div class="palace-grid" @click='Comingsoon'>
          <div class="palace-grid-icon">
            <i class="iconfont iconmingpian yellowcolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>我的名片</h2>
            <h3></h3>
          </div>
        </div>
        <div class="palace-grid" @click='tocomment'>
          <div class="palace-grid-icon">
            <i class="iconfont icontaolunqu yellowcolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>评论区</h2>
            <h3></h3>
          </div>
        </div>
        <div class="palace-grid" @click='getmyposter'>
          <div class="palace-grid-icon">
            <i class="iconfont icontupian bluecolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>推广海报</h2>
            <h3></h3>
          </div>
        </div>
        <div class="palace-grid" @click='showimgbox'>
          <div class="palace-grid-icon">
            <i class="iconfont iconfenxiang bluecolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>好友邀请</h2>
            <h3></h3>
          </div>
        </div>
        <div class="palace-grid" @click='setmydata'>
          <div class="palace-grid-icon">
            <i class="iconfont iconshezhi bluecolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>编辑资料</h2>
            <h3>个人资料&密码</h3>
          </div>
        </div>
        <div class="palace-grid" @click='articleurl'>
          <div class="palace-grid-icon">
            <i class="iconfont iconxiaomi bluecolor"></i>
          </div>
          <div class="palace-grid-text">
            <h2>帮助与客服</h2>
            <h3></h3>
          </div>
        </div>

      </div>
    </div>
    <div class="signout" @click="signOut" v-if="userinfo.usercode">
      <p>退出登录</p>
    </div>
	<div class="icp">ICP证：<a href="http://www.beian.miit.gov.cn" target="_blank">鄂ICP备14007726号</a></div>
    <div style="height:51px;">
      <div id='footer'>
        <dd @click="toindex"><i class="iconfont iconshouye"></i><font>首页</font></dd>
        <dd @click="getmyposter"><i class="iconfont icontupian"></i><font>推广海报</font></dd>
        <dd class="is-selected"><i class="iconfont iconshequ"></i><font>个人中心</font></dd>
      </div>
    </div>
    <div v-show="imgbox" id="actionSheet" class="actionsheet opacity" @touchstart="closeimgbox">
      <img src="../../assets/images/sharetishi.png">
    </div>
    <div style="display:flex;align-items:center;position:fixed;top:0;left:0;bottom:0;right:0;z-index: 999999;background: black;" v-if="posterimg" @click="posterimg=''"><img :src="posterimg" style="width:100%" ></div>
  </div>
</template>

<script>
import { MessageBox } from 'mint-ui';
import { Spinner } from 'mint-ui';
import {mapGetters} from 'vuex';
import { Toast } from 'mint-ui';

import { Indicator } from 'mint-ui';

import { getusercenterdata } from "@/api/api";
import { getInvitePoster } from "@/api/api";
import { getbannerlist } from "@/api/api";

import { mapActions } from "vuex";
export default {
  data(){
    return{
      pageshow:true,
      usercode:'',
      markstatus:'',
      userdata:'',
      imgbox:false,
      posterimg:'',
      banner:[
      ],
      isshowbannner:false
    }
  },
  computed:{
    ...mapGetters({
      userinfo:'userInfo',
    }),
  },
  mounted(){
    /*页面加载*/

    if(!this.checkplogin()){
      this.pageshow=false
      return;
    }
    if(!this.userinfo.mobile){
      this.pageshow=false
      MessageBox({
        title: '未绑定手机号！',
        message: '为了有更好的用户体验，需要绑定手机号才能进入个人中心',
        showCancelButton: true,
        confirmButtonText:'去绑定'
      }).then(action => {
          if(action == 'confirm'){
            this.$router.push('/account/wxauth');
          }
      });
      return;
    }
    this.getbannerlist(4)
    this.setwxshare(window.location.href)
    this.usercode=this.userinfo.usercode
    this.getusercenterdata()
  },
  methods:{
    ...mapActions({
      userOut: "setSignOut"
    }),
    ...mapActions(
      [
        'setUserData','setUserInfo'
      ]
    ),
    getbannerlist(type){
      getbannerlist({ type:type }).then(res => {
        if(res.data.length>0)
        {
          this.isshowbannner=true;
          this.banner=res.data;
        }
      });
    },
    bannnerlink(e){
      var linkurl=e.srcElement.dataset.path;
      if(linkurl!="")
      {
        window.location.href=linkurl;
      }
    },
    setmydata(){
      this.$router.push('/article/userdata');
    },
    tocomment(){
      this.$router.push('/comment/review');
    },
    tomembership(){
      if(!this.checkplogin()){
        return;
      }
      this.$router.push('/user/membership');
    },
    toLogin(){
      this.userOut()
      var invitecode=''
      if (this.$route.query.invitecode){invitecode=this.$route.query.invitecode}
      sessionStorage.setItem('invitecode', invitecode);
      this.$router.push('/account/login');
    },
    tocommunity(e){
      //this.$router.push('/article/community')
      this.$router.push({
          path: '/article/community',
          name: 'community',
          params: {
            communitytype: e,
          }
        })
    },
    showimgbox(){
      this.imgbox=true
      setTimeout(() => { document.getElementById("actionSheet").classList.remove("opacity"); }, 150);
    },
    is_vip(){
      if(this.userinfo.userlevel>0){
        return true;
      }
      else{
        MessageBox({
          title: '提示',
          message: '您不是活动圈会员，暂不能使用该功能',
          showCancelButton: true,
          inputType:'text',
          closeOnClickModal:false,
          confirmButtonText:'去升级'
        }).then(action => {
            if(action == 'confirm'){
              this.tomembership();
            }
        });
        return false;
      }
    },
    getmyposter(){
      if(!this.is_vip()){return}
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      getInvitePoster({usercode:this.userinfo.usercode,}).then(res=>{
        if (res.code==200) {
         Indicator.close()
         this.posterimg=res.data+'?v='+Math.random()
        }else{
          Toast(res.msg)
        }
      })
    },
    closeimgbox(){
      document.getElementById("actionSheet").classList.add("opacity")
      setTimeout(() => { this.imgbox=false }, 150);
    },
    toindex(e){
      var a=localStorage.getItem('IndexType') || 'activity' ;
      this.$router.push('/'+a+'/hot'+a)
    },
    getusercenterdata(){
      var myusercode=''
      if(this.userinfo.usercode){myusercode=this.userinfo.usercode}
      getusercenterdata({ usercode:this.usercode,myusercode:myusercode}).then(res => {
        this.userdata=res.data
        //if(this.userinfo.headerimg!=res.data.headerimg||this.userinfo.username!=res.data.username){
          this.userinfo.headerimg=res.data.headerimg;
          this.userinfo.username=res.data.username;
          this.userinfo.userlevel=res.data.userlevel;
          this.userinfo.invitecode=res.data.invitecode;
          this.userinfo.org=res.data.org;
          this.userinfo.orgintro=res.data.orgintro;
          this.userinfo.contactname=res.data.contactname;
          this.userinfo.contactway=res.data.contactway;
          this.updateuserdata()
        //}
      });
    },
    toactivity(){
      this.$router.push('/user/activity')
    },
    tomatch(){
      this.$router.push('/user/match')
    },
    toarticle(){
      this.$router.push('/user/article')
    },
    articleurl(){
      this.$router.push('/article/articleview?id=130')
    },
    Comingsoon(){
      MessageBox({
        title: '提示',
        message: '敬请期待',
        closeOnClickModal:false,
      }).then(action => {

      });
    },
    tomyorder(index){
      var status=index-1

      this.$router.push('/activity/myorder?status='+status)
    },
    tomyticket(index){
      var status=index-1

      this.$router.push('/activity/myeticket?status='+status)
    },
    tomysign(index){
      var status=index-1

      this.$router.push('/activity/mysign?status='+status)
    },
    toprofit(){
      this.$router.push('/user/profit')
    },
    tomyteam(){
      this.$router.push('/user/myteam')
    },
    checkplogin(){
      if(this.userinfo.usercode){
        return true
      }
      else{
        this.toLogin();
      }
    },
    signOut(){
      console.log(this.userinfo)
      MessageBox({
        title: '提示',
        message: '确认退出登录吗？',
        showCancelButton: true,
        inputType:'text'
      }).then(action => {
          if(action == 'confirm'){
            // MessageBox({
            //   title: '提示',
            //   message: '选择登录方式吗？',
            //   showCancelButton: true,
            //   inputType:'text',
            //   confirmButtonText:"重新授权",
            //   cancelButtonText:"手机号登录"
            // }).then(action => {
            //     if(action == 'confirm'){
            //       this.userdata=''
            //       //this.toLogin();
            //       this.userOut();
            //       Toast("操作成功");
            //     }
            //     else{
            //       this.userdata=''
            //       this.userOut()
            //       var invitecode=''
            //       if (this.$route.query.invitecode){invitecode=this.$route.query.invitecode}
            //       sessionStorage.setItem('invitecode', invitecode);
            //       this.$router.push('/user/login');
            //       Toast("操作成功");
            //     }
            // });
            this.userdata=''
            this.userOut()
            var invitecode=''
            if (this.$route.query.invitecode){invitecode=this.$route.query.invitecode}
            sessionStorage.setItem('invitecode', invitecode);
            this.$router.push('/user/login');
            Toast("操作成功");
          }
      });
    },
    updateuserdata(){
      console.log(this.userinfo);
      this.$store.dispatch('setUserInfo',this.userinfo);
    },
    onCopy(){
      Toast('复制成功')
    },
    onError(){
      Toast('复制失败')
    },
    setwxshare(e){
      let url=e
      let share=[];
      var username=''
      if (this.userinfo.username){username=this.userinfo.username}else{username=this.userinfo.nickname}
      share['title']=username+'邀请您使用活动圈';
      share['desc']='['+this.userinfo.usercode+']活动圈时基于社群和移动互联网的新媒体工具，欢迎注册和使用活动圈。';
      share['shareimg']='';
      share['url']=url+'?invitecode='+this.userinfo.usercode;
      share.callmethod='';
      let wx=this.wxjsapi(url,share,"");
    },
  }
};
</script>

<style lang="stylus" scoped>


.wrapper
  background-color #e7e7e7;
  width 100%
  height 100%

  overflow scroll
  .white-box
    background: #fff;
    border-radius: 5px;
    width: 94%;
    margin:13px auto;
    .flex
      //padding-bottom:5px
      border-bottom:#f5f5f5 solid 1px
      h2
        font-size:15px
    .palace
      padding: 8px 0;
      //display:flex
      overflow: hidden;
      align-items:center
      .palace-grid
        height:75px
        //padding-bottom: 20px;
        cursor: pointer;
        text-align:center
        float:left
        color: #666666;
        min-width:25%
        .palace-grid-icon
          i
            font-size:30px
          .redcolor
            color:#FF8263
          .yellowcolor
            color:#F7B351
          .bluecolor
            color:#71A5E5
        .palace-grid-text
          padding-top: 1px;
          h2
            font-size: 13px;
            font-weight: normal;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          h3
            font-weight: normal;
            font-size: 12px;
            color: #a9a9a9;
            height:17px
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
  .flex-white
    background-color:#ffffff
    cursor: pointer;
  .flex
    display: flex;
    align-items: center;
    padding: 15px;
    position: relative;
    .member
      color: #333;
      font-weight: normal;
      font-size: 13px;
      margin-right: 16px;
  .flex-box
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    min-width: 0;
    font-size: 14px;
    color: #333;
    p
      color: #999;
      font-size: 13px;
  .arrow
    cursor: pointer;
    span
      font-size: 13px;
      color: #9b9b9b;
  .arrow:after
    content: " ";
    display: inline-block;
    height: 8px;
    width: 8px;
    border-width: 2px 2px 0 0;
    border-color: #999;
    border-style: solid;
    transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
    border-radius: 1px;
  .work-bg
    background-image: url(/static/images/head-bg.jpg);
    background-size: cover;
    width: 100%;
    padding-bottom: 3px;
    .bottom-bor
      position: relative;
      .work-user
        width: 80px;
        height: 80px;
        margin-right: 8px;
        img
          width: 80px;
          height: 80px;
          display: block;
          border: none;
          border-radius: 100%;
      .user-text
        color: #fff;
        h1
          font-size: 19px;
          margin-bottom: 5px;
          i
            font-size:22px
            color:#F2CB51
            margin-right:3px
          em
            font-style:normal
            color:#F2CB51
            font-size:13px
        h2
          font-size:13px;
          i
            margin-left:5px
            font-size:13px;
        .work-text
          position: relative;
          width: 100%;
          overflow: hidden;
          .textvalue
            width: 50%;
            float: left;
            text-align: left;
            color: #fff;
            font-size: 13px;
            h5
              font-weight: normal;
              font-size: 16px;
            p
              font-weight: normal;
              font-size: 13px;
              color: #fff;
      .work-button
        button
          background-image: linear-gradient(to right,#39b9ff,#3579e4);
          background-color: #3579e4;
          color: #fff;
          border-radius: 20px;
          border: none;
          font-size: 13px;
          padding: 6px 13px;
    .bottomblin:after
      content: '';
      position: absolute;
      z-index: 2;
      bottom: 0;
      left: 15px;
      width: 92%;
      height: 1px;
      border-bottom: 1px solid #70747b;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
      -webkit-transform-origin: 0 100%;
      transform-origin: 0 100%;
    .work-body
      padding: 15px;
      color: #acadaf;
      font-size: 13px;
      i
        font-style: normal;
        color:#ffffff
        font-size: 19px;
      em
        background: #4285f4;
        color:#ffffff
        font-size: 13px;
        border-radius: 20px;
        font-style: normal;
        padding: 2px 4px;
        font-weight: normal;
        margin-left:5px
      p
        margin-top:5px
  .mint-swipe
    height 80px
    //padding-top  15px
    .mint-swipe-items-wrap
      height 80px
      img
        width 100%
        height 80px
    span
      z-index: 999;
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 3px 10px;
      background: rgba(0,0,0,0.5);
      color: #fff;
  .signout
    padding:15px
    text-align: center;
    background:#fff
    cursor: pointer;
    p
      color:red;
      font-size: 18px;
  #footer
    height: 50px;
    background: #fff;
    padding-top: 4px;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    z-index: 999;
    overflow: hidden;
    border-top: solid 1px #eee;
    .is-selected
      color: #31c27c;
    dd
      width: 33.3333333%;
      text-align: center;
      float: left;
      overflow: hidden;
      color: #333333;
      .mint-tab-item
        display: contents;
      font
        display: block;
        padding-top: 2px;
      i
        width: 24px;
        height: 24px
        font-size:24px
        max-width: 100%;
        border: 0;
        -ms-interpolation-mode: bicubic;
        vertical-align: middle;
  .actionsheet
    position: fixed;
    top: 0;
    left: 0;
    right:0
    bottom:0
    z-index: 10005;
    background-color:rgba(0,0,0,0.3)
    transition: .15s ease-out;

    img
      position: fixed;
      right: 5px;
      top: 5px;
      width: 260px;
      height: 180px;
      z-index: 20001;
.divHeight {
    width: 100%;
    height: 10px;
    background: #f5f5f5;
    position: relative;
    overflow: hidden;
}
.opacity{
  opacity: 0;
}
a {
    text-decoration: none;
    color: #08acee;
}

button {
    outline: 0;
}

img {
    border: 0;
}

button,input,optgroup,select,textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
}

li {
    list-style: none;
}

a {
    color: #666;
}

.clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
}
div, dl, dt, dd, ol, ul, li, h1, h2, h3, h4, h5, h6, p, blockquote, pre, button, fieldset, form, input, legend, textarea, th, td {
    margin: 0;
    padding: 0;
}
.icp
 	text-align:center;
 	margin:30px 0px 30px 0px;
 	a
 		color:orange
.width100
  width: 100vw;

</style>



// WEBPACK FOOTER //
// src/views/User/userinfo.vue